// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"category-list_categoryList__1Q53w","emptyCategory":"category-list_emptyCategory__1Zbwn"};